'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var generated = require('./generated.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const LomaClientContext = /*#__PURE__*/React.createContext(undefined);
const LomaClientProvider = _ref => {
  let {
    children,
    client
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(LomaClientContext.Provider, {
    value: client
  }, children);
};
const useLomaClient = () => React.useContext(LomaClientContext);

exports.CreateClaimAgentDocument = generated.CreateClaimAgentDocument;
exports.CreateClaimDocument = generated.CreateClaimDocument;
exports.DriverLocationsDocument = generated.DriverLocationsDocument;
exports.FormatShipmentEddDocument = generated.FormatShipmentEddDocument;
exports.GetClaimAgentDocument = generated.GetClaimAgentDocument;
exports.GetClaimEligibilityAgentDocument = generated.GetClaimEligibilityAgentDocument;
exports.GetClaimEligibilityDocument = generated.GetClaimEligibilityDocument;
exports.GetClaimsForOrderAgentDocument = generated.GetClaimsForOrderAgentDocument;
exports.GetDecodedParamsDocument = generated.GetDecodedParamsDocument;
exports.GetDefaultLocaleDocument = generated.GetDefaultLocaleDocument;
exports.GetMarketingAssetDocument = generated.GetMarketingAssetDocument;
exports.GetNotificationPreferencesAndLevelDocument = generated.GetNotificationPreferencesAndLevelDocument;
exports.GetSignedUploadLinkDocument = generated.GetSignedUploadLinkDocument;
exports.GetTrackSegmentedExperienceForClaimsDocument = generated.GetTrackSegmentedExperienceForClaimsDocument;
exports.GetUserPrefsNotificationPreferencesDocument = generated.GetUserPrefsNotificationPreferencesDocument;
exports.GetUserPrefsNotificationPreferencesEligibilityDocument = generated.GetUserPrefsNotificationPreferencesEligibilityDocument;
exports.MaptilerDocument = generated.MaptilerDocument;
exports.OrderLookupHeroImageDocument = generated.OrderLookupHeroImageDocument;
exports.SubscribeUserPrefsNotificationPreferencesDocument = generated.SubscribeUserPrefsNotificationPreferencesDocument;
exports.UnsubscribeNotificationPreferencesAllLevelsDocument = generated.UnsubscribeNotificationPreferencesAllLevelsDocument;
exports.UnsubscribeUserPrefsNotificationPreferencesDocument = generated.UnsubscribeUserPrefsNotificationPreferencesDocument;
exports.UpdateClaimAgentDocument = generated.UpdateClaimAgentDocument;
exports.UpdateNotificationPreferencesAllLevelsDocument = generated.UpdateNotificationPreferencesAllLevelsDocument;
exports.useCreateClaimAgentMutation = generated.useCreateClaimAgentMutation;
exports.useCreateClaimMutation = generated.useCreateClaimMutation;
exports.useDriverLocationsLazyQuery = generated.useDriverLocationsLazyQuery;
exports.useDriverLocationsQuery = generated.useDriverLocationsQuery;
exports.useFormatShipmentEddLazyQuery = generated.useFormatShipmentEddLazyQuery;
exports.useFormatShipmentEddQuery = generated.useFormatShipmentEddQuery;
exports.useGetClaimAgentLazyQuery = generated.useGetClaimAgentLazyQuery;
exports.useGetClaimAgentQuery = generated.useGetClaimAgentQuery;
exports.useGetClaimEligibilityAgentLazyQuery = generated.useGetClaimEligibilityAgentLazyQuery;
exports.useGetClaimEligibilityAgentQuery = generated.useGetClaimEligibilityAgentQuery;
exports.useGetClaimEligibilityLazyQuery = generated.useGetClaimEligibilityLazyQuery;
exports.useGetClaimEligibilityQuery = generated.useGetClaimEligibilityQuery;
exports.useGetClaimsForOrderAgentLazyQuery = generated.useGetClaimsForOrderAgentLazyQuery;
exports.useGetClaimsForOrderAgentQuery = generated.useGetClaimsForOrderAgentQuery;
exports.useGetDecodedParamsLazyQuery = generated.useGetDecodedParamsLazyQuery;
exports.useGetDecodedParamsQuery = generated.useGetDecodedParamsQuery;
exports.useGetDefaultLocaleLazyQuery = generated.useGetDefaultLocaleLazyQuery;
exports.useGetDefaultLocaleQuery = generated.useGetDefaultLocaleQuery;
exports.useGetMarketingAssetLazyQuery = generated.useGetMarketingAssetLazyQuery;
exports.useGetMarketingAssetQuery = generated.useGetMarketingAssetQuery;
exports.useGetNotificationPreferencesAndLevelLazyQuery = generated.useGetNotificationPreferencesAndLevelLazyQuery;
exports.useGetNotificationPreferencesAndLevelQuery = generated.useGetNotificationPreferencesAndLevelQuery;
exports.useGetSignedUploadLinkLazyQuery = generated.useGetSignedUploadLinkLazyQuery;
exports.useGetSignedUploadLinkQuery = generated.useGetSignedUploadLinkQuery;
exports.useGetTrackSegmentedExperienceForClaimsLazyQuery = generated.useGetTrackSegmentedExperienceForClaimsLazyQuery;
exports.useGetTrackSegmentedExperienceForClaimsQuery = generated.useGetTrackSegmentedExperienceForClaimsQuery;
exports.useGetUserPrefsNotificationPreferencesEligibilityLazyQuery = generated.useGetUserPrefsNotificationPreferencesEligibilityLazyQuery;
exports.useGetUserPrefsNotificationPreferencesEligibilityQuery = generated.useGetUserPrefsNotificationPreferencesEligibilityQuery;
exports.useGetUserPrefsNotificationPreferencesLazyQuery = generated.useGetUserPrefsNotificationPreferencesLazyQuery;
exports.useGetUserPrefsNotificationPreferencesQuery = generated.useGetUserPrefsNotificationPreferencesQuery;
exports.useMaptilerLazyQuery = generated.useMaptilerLazyQuery;
exports.useMaptilerQuery = generated.useMaptilerQuery;
exports.useOrderLookupHeroImageLazyQuery = generated.useOrderLookupHeroImageLazyQuery;
exports.useOrderLookupHeroImageQuery = generated.useOrderLookupHeroImageQuery;
exports.useSubscribeUserPrefsNotificationPreferencesMutation = generated.useSubscribeUserPrefsNotificationPreferencesMutation;
exports.useUnsubscribeNotificationPreferencesAllLevelsMutation = generated.useUnsubscribeNotificationPreferencesAllLevelsMutation;
exports.useUnsubscribeUserPrefsNotificationPreferencesMutation = generated.useUnsubscribeUserPrefsNotificationPreferencesMutation;
exports.useUpdateClaimAgentMutation = generated.useUpdateClaimAgentMutation;
exports.useUpdateNotificationPreferencesAllLevelsMutation = generated.useUpdateNotificationPreferencesAllLevelsMutation;
exports.LomaClientProvider = LomaClientProvider;
exports.useLomaClient = useLomaClient;
